// import sizes from './MediaSizes';

export default {
    Main: {
        margin: 'auto',
    },
    MainDiv: {
        margin: 'auto',
        marginTop: '56px',
        marginBottom: '0px',
        width: '80%',
        textAlign: 'center',
        '& h3': {
            margin: 'auto',
            color: 'orange',
            fontSize: '56px',
        },
        '& i': {
            margin: 'auto',
            color: 'orange',
            fontSize: '120px',
        },
    },
};
